import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../../shared/DefaultBadge.css';
import '../../weight/lots/WeightLots.css';

const formatHerdLotId = (lotId, prefix) =>
  lotId != null ? `${prefix}-${String(lotId).padStart(4, '0')}` : '-';

const HerdLotCard = ({ row, animalCounts, defaultLotId, onSetDefault, getProtocolName }) => {
  const { t }    = useTranslation();
  const navigate = useNavigate();
  const count    = animalCounts?.[row.lot_id] ?? 0;
  const isDefault = row.lot_id === defaultLotId;
  const protocolName = getProtocolName ? getProtocolName(row.protocol_id) : null;

  return (
    <div className="wl-card" onClick={() => navigate(`/herd/lots/${row.lot_id}`)}>
      <div className="wl-card-main">
        <div className="wl-card-code">{formatHerdLotId(row.lot_id, t('herd_lot_prefix'))}</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          {isDefault && <span className="default-badge">★ {t('default')}</span>}
          <div className="wl-card-chevron">›</div>
        </div>
        {row.name && <div className="wl-card-name">{row.name}</div>}
        <div style={{ fontSize: 12, color: '#666', marginTop: 2 }}>
          {count} {t('tagged_animals').toLowerCase()}
          {row.custom?.animal_count != null && ` · ${t('lot_count')}: ${row.custom.animal_count}`}
          {protocolName && protocolName !== '—' && ` · ${protocolName}`}
        </div>
        {!isDefault && (
          <button
            className="set-default-btn"
            style={{ marginTop: 6 }}
            onClick={(e) => { e.stopPropagation(); onSetDefault?.(row); }}
          >
            {t('set_as_default')}
          </button>
        )}
      </div>
    </div>
  );
};

const HerdLotCardList = ({ data, animalCounts, defaultLotId, onSetDefault, getProtocolName }) => (
  <div className="wl-card-list">
    {data && data.map(row => (
      <HerdLotCard
        key={row._id}
        row={row}
        animalCounts={animalCounts}
        defaultLotId={defaultLotId}
        onSetDefault={onSetDefault}
        getProtocolName={getProtocolName}
      />
    ))}
    {(!data || data.length === 0) && (
      <div className="wl-card-empty">—</div>
    )}
  </div>
);

export default HerdLotCardList;
